/**
 * ADR-0014: the login page asks for an email first and routes its domain
 * to the organization's identity provider, if it has one. The config
 * carries the domains hashed, so the file does not list customers; the
 * domain typed is hashed here and compared. Nothing leaves the browser.
 */
export function emailDomain(email: string): string | undefined {
  const at = email.trim().toLowerCase().lastIndexOf("@");
  if (at < 1) return undefined;
  const domain = email.trim().toLowerCase().slice(at + 1);
  return /^[a-z0-9.-]+\.[a-z]{2,}$/.test(domain) ? domain : undefined;
}

export async function sha256Hex(text: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

/** The IdP identifier to sign in with (the domain itself), or undefined for Cognito's own sign-in. */
export async function ssoRouteFor(email: string, domainHashes: readonly string[]): Promise<string | undefined> {
  const domain = emailDomain(email);
  if (!domain || domainHashes.length === 0) return undefined;
  return domainHashes.includes(await sha256Hex(domain)) ? domain : undefined;
}
